"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyManager = void 0;
var stellar_sdk_1 = require("@stellar/stellar-sdk");
var uint8array_extras_1 = require("uint8array-extras");
var Exceptions_1 = require("./Exceptions");
var freighter_1 = require("./Handlers/freighter");
var albedo_1 = require("./Handlers/albedo");
var ledger_1 = require("./Handlers/ledger");
var plaintextKey_1 = require("./Handlers/plaintextKey");
// TODO - fix trezor errors
// import { trezorHandler } from "./Handlers/trezor";
var Types_1 = require("./Types");
var KeyManager = /** @class */ (function () {
    function KeyManager(params) {
        var _a;
        this.encrypterMap = {};
        this.keyHandlerMap = (_a = {},
            _a[Types_1.KeyType.freighter] = freighter_1.freighterHandler,
            _a[Types_1.KeyType.albedo] = albedo_1.albedoHandler,
            _a[Types_1.KeyType.ledger] = ledger_1.ledgerHandler,
            _a[Types_1.KeyType.plaintextKey] = plaintextKey_1.plaintextKeyHandler,
            _a);
        this.keyCache = {};
        this.keyStore = params.keyStore;
        this.shouldCache = params.shouldCache || false;
        this.defaultNetworkPassphrase =
            params.defaultNetworkPassphrase || stellar_sdk_1.Networks.PUBLIC;
    }
    /**
     * Register a KeyTypeHandler for a given key type.
     * @param {KeyTypeHandler} keyHandler - The key handler.
     */
    KeyManager.prototype.registerKeyHandler = function (keyHandler) {
        this.keyHandlerMap[keyHandler.keyType] = keyHandler;
    };
    /**
     * Register a new encrypter.
     * @param {Encrypter} encrypter - The encrypter.
     */
    KeyManager.prototype.registerEncrypter = function (encrypter) {
        this.encrypterMap[encrypter.name] = encrypter;
    };
    /**
     * Set the default network passphrase
     * @param {string} passphrase - The passphrase.
     */
    KeyManager.prototype.setDefaultNetworkPassphrase = function (passphrase) {
        this.defaultNetworkPassphrase = passphrase;
    };
    /**
     * Stores a key in the keyStore after encrypting it with the encrypterName.
     *
     * @async
     * @param {StoreKeyParams} params - The store key params.
     * @param {Key | UnstoredKey} params.key Key object to store. an `id` field is optional; if you don't
     * provide one, we'll generate a random number. The id will be used to read,
     * change, update, and delete keys.
     * @param {string} params.password encrypt key with this as the secret
     * @param {string} params.encrypterName encryption algorithm to use (must have been
     * registered)
     *
     * @returns {Promise<KeyMetadata>} The metadata of the key
     */
    KeyManager.prototype.storeKey = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var key, password, encrypterName, id, newKey, encrypter, encryptedKey, keyMetadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = params.key, password = params.password, encrypterName = params.encrypterName;
                        id = key.id || "".concat(Math.random());
                        newKey = __assign(__assign({}, key), { id: id });
                        encrypter = this.encrypterMap[encrypterName];
                        return [4 /*yield*/, encrypter.encryptKey({
                                key: newKey,
                                password: password,
                            })];
                    case 1:
                        encryptedKey = _a.sent();
                        return [4 /*yield*/, this.keyStore.storeKeys([encryptedKey])];
                    case 2:
                        keyMetadata = _a.sent();
                        this._writeIndexCache(newKey.id, newKey);
                        return [2 /*return*/, keyMetadata[0]];
                }
            });
        });
    };
    /**
     * Load and decrypt one key, given its id.
     * @param {string} id - the key id
     * @param {string} password - the key password
     * @returns {Key} Decrypted key
     */
    KeyManager.prototype.loadKey = function (id, password) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedKeys, keys, encryptedKey, encrypter, key, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyStore.loadAllKeys()];
                    case 1:
                        encryptedKeys = _a.sent();
                        keys = encryptedKeys.filter(function (k) { return k.id === id; });
                        if (!keys.length) {
                            throw new Error("Key not found with id '".concat(id, "'."));
                        }
                        if (keys.length > 1) {
                            throw new Error("Too many keys found with id '".concat(id, "', that\u2019s not supposed to happen!"));
                        }
                        encryptedKey = keys[0];
                        encrypter = this.encrypterMap[encryptedKey.encrypterName];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, encrypter.decryptKey({
                                encryptedKey: encryptedKey,
                                password: password,
                            })];
                    case 3:
                        key = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        throw new Error("Couldn\u2019t decrypt key '".concat(id, "' with the supplied password."));
                    case 5: return [2 /*return*/, key];
                }
            });
        });
    };
    /**
     *  Get a list of all stored key ids.
     *
     * @returns {Array<string>} List of ids
     */
    KeyManager.prototype.loadAllKeyIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyStore.loadAllKeys()];
                    case 1:
                        encryptedKeys = _a.sent();
                        return [2 /*return*/, encryptedKeys.map(function (key) { return key.id; })];
                }
            });
        });
    };
    /**
     *  Remove the key specified by this key id.
     *
     * @async
     * @param {string} id Specifies which key to remove.
     *    The id is computed as `sha1(private key + public key)`.
     * @returns {Promise<KeyMetadata | undefined>} Metadata of the removed key
     */
    KeyManager.prototype.removeKey = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyStore.removeKey(id)];
                    case 1:
                        res = _a.sent();
                        this._writeIndexCache(id, undefined);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * Sign a transaction using the specified key id. Supports both using a
     * cached key and going out to the keystore to read and decrypt
     *
     * @async
     * @param {SignTransactionParams} params - the sign transaction params
     * @param {Transaction} params.transaction - transaction Transaction object to sign
     * @param {string} params.id - Key to sign with. The id is computed as
     *    `sha1(private key + public key)`.
     * @param {string} params.password - the key password
     * @param {{[key: string]: any}} [params.custom] - custom arguments
     * @returns {Promise<Transaction>} Signed transaction
     */
    KeyManager.prototype.signTransaction = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, id, password, custom, key, encryptedKey, encrypter, keyHandler, signedTransaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transaction = params.transaction, id = params.id, password = params.password, custom = params.custom;
                        key = this._readFromCache(id);
                        if (!!key) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.keyStore.loadKey(id)];
                    case 1:
                        encryptedKey = _a.sent();
                        if (!encryptedKey) {
                            throw new Error("Couldn't sign the transaction: no key with id '".concat(id, "' found."));
                        }
                        encrypter = this.encrypterMap[encryptedKey.encrypterName];
                        return [4 /*yield*/, encrypter.decryptKey({ encryptedKey: encryptedKey, password: password })];
                    case 2:
                        key = _a.sent();
                        this._writeIndexCache(id, key);
                        _a.label = 3;
                    case 3:
                        keyHandler = this.keyHandlerMap[key.type];
                        return [4 /*yield*/, keyHandler.signTransaction({
                                transaction: transaction,
                                key: key,
                                custom: custom,
                            })];
                    case 4:
                        signedTransaction = _a.sent();
                        return [2 /*return*/, signedTransaction];
                }
            });
        });
    };
    // tslint:disable max-line-length
    /**
     * Request an auth token from auth server, which can be used to deposit and
     * withdraw auth-required tokens.
     *
     * Under the hood, it fetches a transaction from the auth server, signs that
     * transaction with the user's key, and returns that transaction for a JWT.
     *
     * https://github.com/stellar/stellar-protocol/blob/master/ecosystem/sep-0010.md
     *
     * @async
     * @param {object} params Params object.
     * @param {string} params.id The user's key to authenticate. The id is
     *                           computed as `sha1(private key + public key)`.
     * @param {string} params.password The password that will decrypt that secret.
     * @param {string} params.authServer The URL of the authentication server.
     * @param {Array} params.authServerHomeDomains The home domain(s) of the
     *                                             authentication server.
     * @param {string} params.authServerKey Check the challenge transaction
     *                                      for this key as source and signature.
     * @param {string} params.clientDomain A domain hosting a SEP-1 stellar.toml
     * containing a SIGNING_KEY used for verifying the client domain. This will
     * be used as the 'client_domain' param on the GET /authServer request.
     * @param {string} params.homeDomain Servers that generate tokens for multiple
     * Home Domains can use this parameter to identify which home domain the Client
     * hopes to authenticate with. This will be used as the 'home_domain' param
     * on the GET /authServer request.
     * @param {Function} params.onChallengeTransactionSignature When
     * `params.clientDomain` is set, you need to provide a function that will add
     * the signature identified by the SIGNING_KEY present on your client domain's
     * toml file. The callback may only append signatures: the returned
     * transaction's hash is compared against the validated challenge and a
     * `DomainSigningModifiedError` is thrown if they differ. That hash covers
     * the operations, source account, sequence number, memo and network
     * passphrase, but not the signatures, so appending a signature is the only
     * change the callback can make.
     * @param {string} [params.account] The authenticating public key. If not
     * provided, then the signers's public key will be used instead.
     * @returns {Promise<string>} authToken JWT.
     */
    // tslint:enable max-line-length
    KeyManager.prototype.fetchAuthToken = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var id, password, authServer, authServerKey, challengeToken, authServerHomeDomains, clientDomain, homeDomain, _a, onChallengeTransactionSignature, account, key, encryptedKey, encrypter, challengeUrl, headers, challengeRes, challengeText, keyNetwork, text, json, transaction, originalHash, returned, keyHandler, signedTransaction, signedTransactionXDR, responseRes, responseText, responseJson, responseResText, _b, token, message, status_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        id = params.id, password = params.password, authServer = params.authServer, authServerKey = params.authServerKey, challengeToken = params.challengeToken, authServerHomeDomains = params.authServerHomeDomains, clientDomain = params.clientDomain, homeDomain = params.homeDomain, _a = params.onChallengeTransactionSignature, onChallengeTransactionSignature = _a === void 0 ? function (tx) {
                            return Promise.resolve(tx);
                        } : _a;
                        account = params.account;
                        // throw errors for missing params
                        if (id === undefined) {
                            throw new Error("Required parameter `id` is missing!");
                        }
                        if (password === undefined) {
                            throw new Error("Required parameter `password` is missing!");
                        }
                        if (!authServer) {
                            throw new Error("Required parameter `authServer` is missing!");
                        }
                        if (!authServerKey) {
                            throw new Error("Required parameter `authServerKey` is missing!");
                        }
                        if (!authServerHomeDomains) {
                            throw new Error("Required parameter `authServerHomeDomains` is missing!");
                        }
                        key = this._readFromCache(id);
                        if (!!key) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.keyStore.loadKey(id)];
                    case 1:
                        encryptedKey = _c.sent();
                        if (!encryptedKey) {
                            throw new Error("Couldn't fetch an auth token: no key with id '".concat(id, "' found."));
                        }
                        encrypter = this.encrypterMap[encryptedKey.encrypterName];
                        return [4 /*yield*/, encrypter.decryptKey({ encryptedKey: encryptedKey, password: password })];
                    case 2:
                        key = _c.sent();
                        this._writeIndexCache(id, key);
                        _c.label = 3;
                    case 3:
                        // If no account has been provided, assume that the signer is the target
                        // account.
                        account = account || key.publicKey;
                        challengeUrl = "".concat(authServer, "?account=").concat(encodeURIComponent(account));
                        if (clientDomain) {
                            challengeUrl += "&client_domain=".concat(encodeURIComponent(clientDomain));
                        }
                        if (homeDomain) {
                            challengeUrl += "&home_domain=".concat(encodeURIComponent(homeDomain));
                        }
                        headers = {};
                        if (challengeToken) {
                            headers = { Authorization: "Bearer ".concat(challengeToken) };
                        }
                        return [4 /*yield*/, fetch(challengeUrl, { headers: headers })];
                    case 4:
                        challengeRes = _c.sent();
                        if (!(challengeRes.status !== 200)) return [3 /*break*/, 6];
                        return [4 /*yield*/, challengeRes.text()];
                    case 5:
                        challengeText = _c.sent();
                        throw new Error("[KeyManager#fetchAuthToken] Failed to fetch a challenge transaction,\n          error: ".concat(JSON.stringify(challengeText)));
                    case 6:
                        keyNetwork = key.network || this.defaultNetworkPassphrase;
                        return [4 /*yield*/, challengeRes.text()];
                    case 7:
                        text = _c.sent();
                        try {
                            json = JSON.parse(text);
                        }
                        catch (e) {
                            throw new Error("Request for challenge returned invalid JSON: ".concat(text));
                        }
                        if (json.error) {
                            throw new Error(json.error);
                        }
                        // Throw error when network_passphrase is returned, and doesn't match
                        if (json.network_passphrase !== undefined &&
                            keyNetwork !== json.network_passphrase) {
                            throw new Error("Network mismatch: the transfer server expects \"".concat(json.network_passphrase, "\", but you're using \"").concat(keyNetwork, "\""));
                        }
                        transaction = stellar_sdk_1.WebAuth.readChallengeTx(json.transaction, authServerKey, keyNetwork, authServerHomeDomains, new URL(authServer).hostname).tx;
                        originalHash = transaction.hash();
                        return [4 /*yield*/, onChallengeTransactionSignature(transaction)];
                    case 8:
                        returned = _c.sent();
                        // Transaction.hash() covers the envelope body and the network passphrase but
                        // excludes signatures, so a callback that only appends the client_domain
                        // signature preserves the hash. Any change to the operations, source
                        // account, sequence number, memo or network changes the hash and is
                        // rejected here, so the validated challenge is what actually gets signed.
                        if (!(0, uint8array_extras_1.areUint8ArraysEqual)(returned.hash(), originalHash)) {
                            throw new Exceptions_1.DomainSigningModifiedError();
                        }
                        transaction = returned;
                        keyHandler = this.keyHandlerMap[key.type];
                        return [4 /*yield*/, keyHandler.signTransaction({
                                transaction: transaction,
                                key: key,
                            })];
                    case 9:
                        signedTransaction = _c.sent();
                        signedTransactionXDR = signedTransaction
                            .toEnvelope()
                            .toXdr("base64");
                        return [4 /*yield*/, fetch(authServer, {
                                method: "POST",
                                body: JSON.stringify({
                                    transaction: signedTransactionXDR,
                                }),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })];
                    case 10:
                        responseRes = _c.sent();
                        if (!(responseRes.status !== 200)) return [3 /*break*/, 12];
                        return [4 /*yield*/, responseRes.text()];
                    case 11:
                        responseText = _c.sent();
                        try {
                            responseJson = JSON.parse(responseText);
                            throw new Error("[KeyManager#fetchAuthToken] Failed to return a signed transaction,\n          error: ".concat(responseJson.error));
                        }
                        catch (e) {
                            throw new Error("[KeyManager#fetchAuthToken] Failed to return a signed transaction,\n          error code ".concat(responseRes.status, " and status text\n          \"").concat(responseText, "\""));
                        }
                        _c.label = 12;
                    case 12: return [4 /*yield*/, responseRes.text()];
                    case 13:
                        responseResText = _c.sent();
                        try {
                            _b = JSON.parse(responseResText), token = _b.token, message = _b.message, status_1 = _b.status;
                            // if we get a false status message, error out
                            if (status_1 === false && message) {
                                throw new Error(message);
                            }
                            return [2 /*return*/, token];
                        }
                        catch (e) {
                            throw new Error("[KeyManager#fetchAuthToken] Failed to validate signed transaction\n        response, server responded with ".concat(responseResText));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the stored keys to be encrypted with the new password.
     *
     * @async
     * @param {ChangePasswordParams} params - the change password params
     * @param {string} params.oldPassword - the user's old password
     * @param {string} params.newPassword - the user's new password
     * @returns {Promise<KeyMetadata[]>} the key meta data
     */
    KeyManager.prototype.changePassword = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var oldPassword, newPassword, oldKeys, newKeys;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldPassword = params.oldPassword, newPassword = params.newPassword;
                        return [4 /*yield*/, this.keyStore.loadAllKeys()];
                    case 1:
                        oldKeys = _a.sent();
                        return [4 /*yield*/, Promise.all(oldKeys.map(function (encryptedKey) { return __awaiter(_this, void 0, void 0, function () {
                                var encrypter, decryptedKey;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            encrypter = this.encrypterMap[encryptedKey.encrypterName];
                                            return [4 /*yield*/, encrypter.decryptKey({
                                                    encryptedKey: encryptedKey,
                                                    password: oldPassword,
                                                })];
                                        case 1:
                                            decryptedKey = _a.sent();
                                            this._writeIndexCache(decryptedKey.id, decryptedKey);
                                            return [2 /*return*/, encrypter.encryptKey({
                                                    key: decryptedKey,
                                                    password: newPassword,
                                                })];
                                    }
                                });
                            }); }))];
                    case 2:
                        newKeys = _a.sent();
                        return [2 /*return*/, this.keyStore.updateKeys(newKeys)];
                }
            });
        });
    };
    KeyManager.prototype._readFromCache = function (id) {
        if (!this.shouldCache) {
            return undefined;
        }
        return this.keyCache[id];
    };
    KeyManager.prototype._writeIndexCache = function (id, key) {
        if (!this.shouldCache) {
            return;
        }
        if (key) {
            this.keyCache[id] = key;
        }
        else {
            delete this.keyCache[id];
        }
    };
    return KeyManager;
}());
exports.KeyManager = KeyManager;
